import apiClient from './apiClient'

/**
 * Send application
 * @param {object} payload Form data for application
 * @returns 
 */
export const sendResellerApplication = async (payload) => await apiClient.post('/api/ResellerApplication', payload)